import { Component, OnInit, Input } from '@angular/core';

import { HelperService, DataService, DateService } from 'app/services';
import { config } from 'app/constants';

@Component({
  selector: 'app-appointment-card',
  templateUrl: './appointment-card.component.html',
  styleUrls: ['./appointment-card.component.scss'],
})
export class AppointmentCardComponent implements OnInit {
  @Input() appointment: any;
  @Input() index: number;
  @Input() tab: string;
  @Input() isPast: boolean = false;

  constructor(
    public helperService: HelperService,
    private dataService: DataService,
    public dateService: DateService
  ) {}

  ngOnInit() {
    this.appointment = this.formatAppointment(this.appointment);
  }

  formatAppointment(appointment: any) {
    let startDateTime;

    if (this.helperService.isAppleDevice()) {
      startDateTime = new Date(
        this.dateService.madeDateStringIOSCompatible(appointment.start)
      );
    } else {
      startDateTime = new Date(appointment.start);
    }

    return {
      ...appointment,
      title: appointment.title || config.defaultTitle,
      code: (appointment.estimate && appointment.estimate.code) || '',
      month: this.dateService.formatDate(startDateTime, 'MMM'),
      date: this.dateService.formatDate(startDateTime, 'DD'),
      time: this.dateService.formatDate(startDateTime, 'hh:mm a'),
      vehicleName:
        (appointment.vehicle && appointment.vehicle.name) ||
        config.defaultTitle,
    };
  }

  openAppointmentModal(appointment: any) {
    this.dataService.sendData(
      this.dataService.typeDialog(
        'add-appointment',
        'calendar-view',
        appointment._id,
        null,
        appointment
      )
    );
  }
}
